import { createStyles, Theme } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';

const styles = ({
  colors, spacing, breakpoints, typography,
}: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    borderRadius: colors.pageElements.flyOutNotifications.corner,
    padding: spacing(3),
    marginBottom: spacing(3),
    position: 'relative',
    zIndex: zIndex.snackbar,
    [breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  alignCenter: {
    alignItems: 'center',
  },
  plain: {
    padding: spacing(3),
    zIndex: 1,
    '& $message': {
      marginTop: spacing(1.5),
    },
  },
  title: {
    color: colors.pageElements.flyOutNotifications.title,
  },
  plainMessage: {
    ...typography.textRegular,
  },
  notification: {
    boxSizing: 'border-box',
    boxShadow: colors.pageElements.flyOutNotifications.dropdownMenuShadow,
    width: spacing(77),
  },
  info: {
    backgroundColor: colors.pageElements.flyOutNotifications.backgroundInfo,
    outline: `1px solid ${colors.pageElements.flyOutNotifications.strokeInfo}`,
  },
  error: {
    backgroundColor: colors.pageElements.flyOutNotifications.backgroundError,
    outline: `1px solid ${colors.pageElements.flyOutNotifications.strokeError}`,
  },
  warning: {
    backgroundColor: colors.pageElements.flyOutNotifications.backgroundWarning,
    outline: `1px solid ${colors.pageElements.flyOutNotifications.strokeWarning}`,
  },
  success: {
    backgroundColor: colors.pageElements.flyOutNotifications.backgroundSuccess,
    outline: `1px solid ${colors.pageElements.flyOutNotifications.strokeSuccess}`,
  },
  service: {
    backgroundColor: colors.pageElements.flyOutNotifications.backgroundService,
    outline: `1px solid ${colors.pageElements.flyOutNotifications.strokeService}`,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
  },
  message: {
    marginTop: spacing(1),
    color: colors.pageElements.flyOutNotifications.description,
  },
  close: {
    marginLeft: spacing(2),
    alignSelf: 'flex-start',
  },
  icon: {
    marginRight: spacing(2),
    fontSize: 26,
  },
  button: {
    marginTop: spacing(2),
    '& button': {
      width: '100%',
    },
  },
});

export default styles;
